module.exports = __webpack_public_path__ + "img/copy.3d33fa29.svg";